
export const BASE_URL = "https://hotel.mogasoft.com";
// export const BASE_URL = "http://localhost:8000";


// Dashboard
export const APIClubDashboardStats = BASE_URL + "/api/dashboard/club/stats";
export const APIBarDashboardStats = BASE_URL + "/api/dashboard/bar/stats";
export const APIRestaurantDashboardStats= BASE_URL + "/api/dashboard/restaurant/stats";
// ============================================================================

// Settings Users
export const APIUserStore = BASE_URL+"/api/settings/user/store";
export const APIUserList = BASE_URL+"/api/settings/user/list";
export const APIUserNames = BASE_URL+"/api/settings/user/names";
export const APIUserLogin = BASE_URL+"/api/settings/user/login";
export const APIUserUpdate = BASE_URL+"/api/settings/user/update";
export const APIUserDelete = BASE_URL+"/api/settings/user/delete";
export const APIUserUpdatePassword = BASE_URL+"/api/settings/user/update/password";

// Settings Branche
export const APIBrancheList = BASE_URL+"/api/settings/branche/list";
export const APIBrancheNames = BASE_URL+"/api/settings/branche/names";
export const APIBrancheStore = BASE_URL+"/api/settings/branche/store";
export const APIBrancheUpdate = BASE_URL+"/api/settings/branche/update";
export const APIBrancheDelete = BASE_URL+"/api/settings/branche/delete";
export const APIBrancheNamesFilter = BASE_URL+"/api/settings/branche/names";
// ================================================================================




// ======================================= Customers End ================================================

// Payment APIs
export const APIPaymentsList = BASE_URL+"/api/payments";
export const APIPaymentsStatistics = BASE_URL+"/api/payments/statistics";
export const APIPaymentsCreate = BASE_URL+"/api/payments/create";
export const APIPaymentsUpdate = BASE_URL+"/api/payments/update";
export const APIPaymentsDelete = BASE_URL+"/api/payments/delete";
export const APIPaymentReceipt = BASE_URL+"/api/payments/receipt";


// ============================================================================
// units Supplier
export const APISupplierList = BASE_URL+"/api/units/supplier/list";
export const APISupplierStore = BASE_URL+"/api/units/supplier/store";
export const APISupplierNames = BASE_URL+"/api/units/supplier/names";
export const APISupplierUpdate = BASE_URL+"/api/units/supplier/update";
export const APISupplierDelete = BASE_URL+"/api/units/supplier/delete";


// units Units APIs
export const APIUnitesList = BASE_URL+"/api/units/units/list";
export const APIUnitesNames = BASE_URL+"/api/units/units/names";
export const APIUnitesActive = BASE_URL+"/api/units/units/active";
export const APIUnitesShow = BASE_URL+"/api/units/units/show";
export const APIUnitesStore = BASE_URL+"/api/units/units/store";
export const APIUnitesUpdate = BASE_URL+"/api/units/units/update";
export const APIUnitesDelete = BASE_URL+"/api/units/units/delete";

// units Destroyed
export const APIDestroyedList = BASE_URL+"/api/units/destroyed/list";
export const APIDestroyedStore = BASE_URL+"/api/units/destroyed/store";
export const APIDestroyedUpdate = BASE_URL+"/api/units/destroyed/update";
export const APIDestroyedDelete = BASE_URL+"/api/units/destroyed/delete";
// =========================================================================================

// ========================================== room-settings Start ===============================================

// room-settings Bed Type APIs
export const APIBookingTypeList = BASE_URL+"/api/room-settings/booking-type/list";
export const APIBookingTypeStore = BASE_URL+"/api/room-settings/booking-type/store";
export const APIBookingTypeNames = BASE_URL+"/api/room-settings/booking-type/names";
export const APIBookingTypeUpdate = BASE_URL+"/api/room-settings/booking-type/update";
export const APIBookingTypeDelete = BASE_URL+"/api/room-settings/booking-type/delete";
export const APIBookingTypeActive = BASE_URL+"/api/room-settings/booking-type/active";
export const APIBookingTypeStatistics = BASE_URL+"/api/room-settings/booking-type/statistics";


// room-settings Booking Source APIs
export const APIBookingSourceList = BASE_URL+"/api/room-settings/booking-source/list";
export const APIBookingSourceStore = BASE_URL+"/api/room-settings/booking-source/store";
export const APIBookingSourceNames = BASE_URL+"/api/room-settings/booking-source/names";
export const APIBookingSourceUpdate = BASE_URL+"/api/room-settings/booking-source/update";
export const APIBookingSourceDelete = BASE_URL+"/api/room-settings/booking-source/delete";
export const APIBookingSourceActive = BASE_URL+"/api/room-settings/booking-source/active";
export const APIBookingSourceStatistics = BASE_URL+"/api/room-settings/booking-source/statistics";

// Room APIs
export const APIRoomList = BASE_URL+"/api/room-settings/room/list";
export const APIRoomStore = BASE_URL+"/api/room-settings/room/store";
export const APIRoomNames = BASE_URL+"/api/room-settings/room/names";
export const APIRoomUpdate = BASE_URL+"/api/room-settings/room/update";
export const APIRoomDelete = BASE_URL+"/api/room-settings/room/delete";
export const APIRoomActive = BASE_URL+"/api/room-settings/room/active";
export const APIRoomStatistics = BASE_URL+"/api/room-settings/room/statistics";
export const APIRoomSearch = BASE_URL+"/api/room-settings/room/search";

// ========================================== room-settings End ===============================================



// ========================================== reservation Start ===============================================

export const APIBookingList = BASE_URL+"/api/reservation/booking/list";
export const APIBookingReport = BASE_URL+"/api/booking/report/report";
export const APIBookingStats = BASE_URL+"/api/booking/report/stats";
export const APIBookingNames = BASE_URL+"/api/reservation/booking/names";
export const APIBookingStore = BASE_URL+"/api/reservation/booking/store";
export const APIBookingUpdate = BASE_URL+"/api/reservation/booking/update";
export const APIBookingDelete = BASE_URL+"/api/reservation/booking/delete";
export const APIBookingCheckIn = BASE_URL+"/api/reservation/booking/check-in";
export const APIBookingCheckOut = BASE_URL+"/api/reservation/booking/check-out";
export const APIBookingCancel = BASE_URL+"/api/reservation/booking/cancel";
export const APIBookingStatistics = BASE_URL+"/api/reservation/booking/statistics";
export const APITodaysCheckIns = BASE_URL+"/api/reservation/booking/todays-checkins";
export const APITodaysCheckOuts = BASE_URL+"/api/reservation/booking/todays-checkouts";
export const APIAvailableRooms = BASE_URL+"/api/reservation/booking/available-rooms";

// ========================================== reservation End ===============================================


export const APIGuestOrders = BASE_URL + "/api/check-out/guest-orders";
export const APIProcessCheckout = BASE_URL + "/api/check-out/process-checkout";
export const APICheckoutSummary = BASE_URL + "/api/check-out/checkout-summary";





// ========================================= Customer Start ==========================
// Customer APIs
export const APICustomerNames = ""
export const APIPaymentHistory = BASE_URL + "/api/customer/payment/history";

// Guest
export const APIGuestList = BASE_URL + "/api/customer/guest/list";
export const APIGuestStore = BASE_URL + "/api/customer/guest/store";
export const APIGuestNames = BASE_URL + "/api/customer/guest/names";
export const APIGuestUpdate = BASE_URL + "/api/customer/guest/update";
export const APIGuestDelete = BASE_URL + "/api/customer/guest/delete";
export const APIGuestActive = BASE_URL + "/api/customer/guest/active";
export const APIGuestStatistics = BASE_URL + "/api/customer/guest/statistics";
export const APIGuestSearch = BASE_URL + "/api/customer/guest/search";

// wake-up-call
export const APIWakeUpCallList = BASE_URL+"/api/customer/wake-up-call/list";
export const APIWakeUpCallStore = BASE_URL+"/api/customer/wake-up-call/store";
export const APIWakeUpCallUpdate = BASE_URL+"/api/customer/wake-up-call/update";
export const APIWakeUpCallDelete = BASE_URL+"/api/customer/wake-up-call/delete";
export const APIWakeUpCallMarkCompleted = BASE_URL+"/api/customer/wake-up-call/mark-completed";
export const APIWakeUpCallCheckedInCustomers = BASE_URL+"/api/customer/wake-up-call/checked-in-customers";
export const APIWakeUpCallStatistics = BASE_URL+"/api/customer/wake-up-call/statistics";
export const APIWakeUpCallTodaysCalls = BASE_URL+"/api/customer/wake-up-call/todays-calls";

// ========================================= Customer End ==========================


//  ================================== guest-house Start ===============================

// Guest House APIs
export const APIGuestBookingList = BASE_URL + "/api/guest-house/guest-house/list";
export const APIGuestBookingStore = BASE_URL + "/api/guest-house/guest-house/store";
export const APIGuestBookingUpdate = BASE_URL + "/api/guest-house/guest-house/update";
export const APIGuestBookingDelete = BASE_URL + "/api/guest-house/guest-house/delete";
export const APIGuestBookingStatistics = BASE_URL + "/api/guest-house/guest-house/statistics";

export const APIHiringVenuList = BASE_URL+"/api/guest-house/hiring-venu/list";
export const APIHiringVenuStore = BASE_URL+"/api/guest-house/hiring-venu/store";
export const APIHiringVenuUpdate = BASE_URL+"/api/guest-house/hiring-venu/update";
export const APIHiringVenuDelete = BASE_URL+"/api/guest-house/hiring-venu/delete";
export const APIHiringVenuStatistics = BASE_URL + "/api/guest-house/hiring-venu/statistics";

export const APISaunaList = BASE_URL+"/api/guest-house/sauna/list";
export const APISaunaStore = BASE_URL+"/api/guest-house/sauna/store";
export const APISaunaUpdate = BASE_URL+"/api/guest-house/sauna/update";
export const APISaunaDelete = BASE_URL+"/api/guest-house/sauna/delete";
export const APISaunaStatistics = BASE_URL + "/api/guest-house/sauna/statistics";

export const APIGymList = BASE_URL+"/api/guest-house/gym/list";
export const APIGymStore = BASE_URL+"/api/guest-house/gym/store";
export const APIGymUpdate = BASE_URL+"/api/guest-house/gym/update";
export const APIGymDelete = BASE_URL+"/api/guest-house/gym/delete";
export const APIGymStatistics = BASE_URL + "/api/guest-house/gym/statistics";
//  ================================== guest-house End ===============================



//  ================================== event-management Start ===============================

export const APIHiringPlaceList = BASE_URL + "/api/event-management/place/list";
export const APIHiringPlaceStore = BASE_URL + "/api/event-management/place/store";
export const APIHiringPlaceUpdate = BASE_URL + "/api/event-management/place/update";
export const APIHiringPlaceDelete = BASE_URL + "/api/event-management/place/delete";
export const APIHiringPlaceStatistics = BASE_URL + "/api/event-management/place/statistics";

export const APIHiringChairList = BASE_URL + "/api/event-management/chair/list";
export const APIHiringChairStore = BASE_URL + "/api/event-management/chair/store";
export const APIHiringChairUpdate = BASE_URL + "/api/event-management/chair/update";
export const APIHiringChairDelete = BASE_URL + "/api/event-management/chair/delete";
export const APIHiringChairStatistics = BASE_URL + "/api/event-management/chair/statistics";

export const APIDecorrotionList = BASE_URL + "/api/event-management/decorrotion/list";
export const APIDecorrotionStore = BASE_URL + "/api/event-management/decorrotion/store";
export const APIDecorrotionUpdate = BASE_URL + "/api/event-management/decorrotion/update";
export const APIDecorrotionDelete = BASE_URL + "/api/event-management/decorrotion/delete";
export const APIDecorrotionStatistics = BASE_URL + "/api/event-management/decorrotion/statistics";

export const APITentList = BASE_URL + "/api/event-management/tent/list";
export const APITentStore = BASE_URL + "/api/event-management/tent/store";
export const APITentUpdate = BASE_URL + "/api/event-management/tent/update";
export const APITentDelete = BASE_URL + "/api/event-management/tent/delete";
export const APITentStatistics = BASE_URL + "/api/event-management/tent/statistics";

export const APIAddressSystemList = BASE_URL + "/api/event-management/address-system/list";
export const APIAddressSystemStore = BASE_URL + "/api/event-management/address-system/store";
export const APIAddressSystemUpdate = BASE_URL + "/api/event-management/address-system/update";
export const APIAddressSystemDelete = BASE_URL + "/api/event-management/address-system/delete";
export const APIAddressSystemStatistics = BASE_URL + "/api/event-management/address-system/statistics";

//  ================================== event-management End ===============================



//  ================================== hr Start ===============================
export const APIPositionList = BASE_URL + "/api/hr-employee/position/list";
export const APIPositionStore = BASE_URL + "/api/hr-employee/position/store";
export const APIPositionNames = BASE_URL + "/api/hr-employee/position/names";
export const APIPositionUpdate = BASE_URL + "/api/hr-employee/position/update";
export const APIPositionDelete = BASE_URL + "/api/hr-employee/position/delete";

// Employee APIs
export const APIEmployeeList = BASE_URL + "/api/hr-employee/employee/list";
export const APIEmployeeStore = BASE_URL + "/api/hr-employee/employee/store";
export const APIEmployeeNames = BASE_URL + "/api/hr-employee/employee/names";
export const APIEmployeeUpdate = BASE_URL + "/api/hr-employee/employee/update";
export const APIEmployeeImage = BASE_URL + "/api/hr-employee/employee/image/";
export const APIEmployeeDelete = BASE_URL + "/api/hr-employee/employee/delete";

export const APISalaryList = BASE_URL+"/api/hr-employee/salary/list";
export const APISalaryStore = BASE_URL+"/api/hr-employee/salary/store";
export const APISalaryUpdate = BASE_URL+"/api/hr-employee/salary/update";
export const APISalaryDelete = BASE_URL+"/api/hr-employee/salary/delete";

// Performance APIs
export const APIPerformanceList = BASE_URL+"/api/hr-employee/performance/list";
export const APIPerformanceStore = BASE_URL+"/api/hr-employee/performance/store";
export const APIPerformanceUpdate = BASE_URL+"/api/hr-employee/performance/update";
export const APIPerformanceDelete = BASE_URL+"/api/hr-employee/performance/delete";

export const APIDepartmentList = BASE_URL+"/api/hr-department/department/list";
export const APIDepartmentNames = BASE_URL + "/api/hr-department/department/names";
export const APIDepartmentStore = BASE_URL+"/api/hr-department/department/store";
export const APIDepartmentUpdate = BASE_URL+"/api/hr-department/department/update";
export const APIDepartmentDelete = BASE_URL+"/api/hr-department/department/delete";


//  ================================== hr End ===============================







// ============================= restaurant Start ============================================

export const APCustomerTypeList = BASE_URL + "/api/restaurant/type/list";
export const APCustomerTypeNames = BASE_URL + "/api/restaurant/type/names";
export const APCustomerTypeStore = BASE_URL + "/api/restaurant/type/store";
export const APCustomerTypeUpdate = BASE_URL + "/api/restaurant/type/update";
export const APCustomerTypeDelete = BASE_URL + "/api/restaurant/type/delete";

export const APIFoodCategoryList = BASE_URL + "/api/restaurant-category/category/list";
export const APIFoodCategoryStore = BASE_URL + "/api/restaurant-category/category/store";
export const APIFoodCategoryNames = BASE_URL + "/api/restaurant-category/category/names";
export const APIFoodCategoryUpdate = BASE_URL + "/api/restaurant-category/category/update";
export const APIFoodCategoryDelete = BASE_URL + "/api/restaurant-category/category/delete";
export const APIFoodCategoryImage = BASE_URL +"/api/restaurant-category/category/image/";


export const APIFoodList = BASE_URL + "/api/food/list";
export const APIFoodStore = BASE_URL + "/api/food/store";
export const APIFoodNames = BASE_URL + "/api/food/names";
export const APIFoodUpdate = BASE_URL + "/api/food/update";
export const APIFoodDelete = BASE_URL + "/api/food/delete";
export const APIFoodImage = BASE_URL + "/api/food/image/";

// Restaurant Inventory APIs
export const APIRestaurantInventoryList = BASE_URL + "/api/restaurant/inventory/list";
export const APIRestaurantInventoryStore = BASE_URL + "/api/restaurant/inventory/store";
export const APIRestaurantInventoryUpdate = BASE_URL + "/api/restaurant/inventory/update";
export const APIRestaurantInventoryDelete = BASE_URL + "/api/restaurant/inventory/delete";
export const APIRestaurantInventoryReport = BASE_URL + "/api/restaurant/inventory/report/report";
export const APIRestaurantInventoryStats = BASE_URL + "/api/restaurant/inventory/report/stats";
export const APIRestaurantStockNames = BASE_URL + "/api/restaurant-stock/names";


// Restaurant Stock APIs
export const APIRestaurantList = BASE_URL + "/api/restaurant-stock/list";
export const APIRestaurantNames = BASE_URL + "/api/restaurant-stock/names";
export const APIRestaurantStats = BASE_URL + "/api/restaurant-stock/stats";
export const APIRestaurantStore = BASE_URL + "/api/restaurant-stock/store";
export const APIRestaurantUpdate = BASE_URL + "/api/restaurant-stock/update";
export const APIRestaurantDelete = BASE_URL + "/api/restaurant-stock/delete";
export const APIRestaurantUpdateBalance = BASE_URL + "/api/restaurant-stock/update-balance";
export const APIRestaurantHistory = BASE_URL + "/api/restaurant-stock/history/";
export const APIRestaurantTaking = BASE_URL + "/api/restaurant-stock/stock-taking";

// Restaurant Report APIs
export const APIRestaurantReport = BASE_URL + "/api/restaurant-report/generate";

// Food Ingredient APIs
export const APIIngredientList = BASE_URL + "/api/ingredient/list";
export const APIIngredientNames = BASE_URL + "/api/ingredient/names";
export const APIIngredientStats = BASE_URL + "/api/ingredient/stats";
export const APIIngredientStore = BASE_URL + "/api/ingredient/store";
export const APIIngredientUpdate = BASE_URL + "/api/ingredient/update";
export const APIIngredientBalance = BASE_URL + "/api/ingredient/stock-balance";
export const APIIngredientAdjust = BASE_URL + "/api/ingredient/adjust";
export const APIIngredientDelete = BASE_URL + "/api/ingredient/delete";
export const APIIngredientReport = BASE_URL + "/api/ingredient/report";
export const APIIngredientUpdateBalance = BASE_URL + "/api/ingredient/update-balance";
export const APIIngredientHistory = BASE_URL + "/api/ingredient/history/";
export const APIIngredientTaking = BASE_URL + "/api/ingredient/stock-taking";
// Ingredient Inventory APIs
export const APIIngredientInventoryList = BASE_URL+"/api/ingredient/inventory/list";
export const APIIngredientInventoryStore = BASE_URL+"/api/ingredient/inventory/store";
export const APIIngredientInventoryUpdate = BASE_URL+"/api/ingredient/inventory/update";
export const APIIngredientInventoryDelete = BASE_URL+"/api/ingredient/inventory/delete";
export const APIIngredientInventoryStocksByCounter = BASE_URL+"/api/ingredient/inventory/stocks-by-counter";
export const APIIngredientInventoryReport = BASE_URL+"/api/ingredient/inventory/report/report";
export const APIIngredientInventoryStats = BASE_URL+"/api/ingredient/inventory/report/stats";

// Pos
export const APIPosKitchenListBy = BASE_URL + "/api/order/pos/kitchen/list/by/";

// Orders
export const APIOrderStore = BASE_URL + "/api/order/store";
export const APIOrderList = BASE_URL + "/api/order/list";
export const APIOrderUpdate = BASE_URL + "/api/order/update";
export const APIOrderDelete = BASE_URL + "/api/order/delete";
export const APIOrderPayment = BASE_URL + "/api/order/payment";
export const APICustomerPendingOrders =  BASE_URL + "/api/order/orders/pending"
// Orders Report APIs
export const APIOrdersReport = BASE_URL + "/api/order/report/list";
export const APIOrdersReportDetails = BASE_URL + "/api/order/report/details";
export const APIOrdersReportStatistics = BASE_URL + "/api/order/report/statistics";
export const APIOrdersReportExport = BASE_URL + "/api/order/report/export";
export const APIOrdersReportTrends = BASE_URL + "/api/order/report/trends";
// ============================= restaurant End ============================================



// ============================= room facility Start ============================================

// Facility Types APIs
export const APIFacilityTypeList = BASE_URL+"/api/room-facility/type/list";
export const APIFacilityTypeStore = BASE_URL+"/api/room-facility/type/store";
export const APIFacilityTypeUpdate = BASE_URL+"/api/room-facility/type/update";
export const APIFacilityTypeDelete = BASE_URL+"/api/room-facility/type/delete";
export const APIFacilityTypeNames = BASE_URL+"/api/room-facility/type/names";


// ============================= housing keeping  Start ============================================
// Room Cleaning APIs



// System Logs APIs
export const APISystemLogsList = BASE_URL + "/api/system-logs/list";
export const APISystemLogsStore = BASE_URL + "/api/system-logs/store";
export const APISystemLogsUpdate = BASE_URL + "/api/system-logs/update";
export const APISystemLogsDelete = BASE_URL + "/api/system-logs/delete";
export const APISystemLogsStatistics = BASE_URL + "/api/system-logs/statistics";



// ============================= housing keeping  End ============================================

// ============================= duty-roster Start ============================================

export const APIShiftTypeList = BASE_URL + "/api/duty-roster/shift-type/list";
export const APIShiftTypeNames = BASE_URL + "/api/duty-roster/shift-type/names";
export const APIShiftTypeStore = BASE_URL + "/api/duty-roster/shift-type/store";
export const APIShiftTypeUpdate = BASE_URL + "/api/duty-roster/shift-type/update";
export const APIShiftTypeDelete = BASE_URL + "/api/duty-roster/shift-type/delete";

// Shift APIs
export const APIShiftList = BASE_URL + "/api/duty-roster/shift/list";
export const APIShiftStore = BASE_URL + "/api/duty-roster/shift/store";
export const APIShiftUpdate = BASE_URL + "/api/duty-roster/shift/update";
export const APIShiftDelete = BASE_URL + "/api/duty-roster/shift/delete";

// ============================= duty-roster End ============================================

// ============================= club Start ============================================

// Counter APIs
export const APICounterList = BASE_URL+"/api/club/counter/list";
export const APICounterStore = BASE_URL+"/api/club/counter/store";
export const APICounterUpdate = BASE_URL+"/api/club/counter/update";
export const APICounterDelete = BASE_URL+"/api/club/counter/delete";
export const APICounterNames = BASE_URL+"/api/club/counter/names";

// Stock APIs
export const APIStockList = BASE_URL + "/api/club/stock/list";
export const APIStockNames = BASE_URL + "/api/club/stock/names";
export const APIStockStats = BASE_URL + "/api/club/stock/stats";
export const APIStockStore = BASE_URL + "/api/club/stock/store";
export const APIStockUpdate = BASE_URL + "/api/club/stock/update";
export const APIStockAdjust = BASE_URL + "/api/club/stock/adjust";
export const APIStockDelete = BASE_URL + "/api/club/stock/delete";
export const APIStockReport = BASE_URL + "/api/club/stock/report";
export const APIStockUpdateBalance = BASE_URL + "/api/club/stock/update-balance";
export const APIStockHistory = BASE_URL + "/api/club/stock/history/";
export const APIStockTaking = BASE_URL + "/api/club/stock/stock-taking";

// Club Inventory APIs
export const APIClubInventoryList = BASE_URL+"/api/club/inventory/list";
export const APIClubInventoryStore = BASE_URL+"/api/club/inventory/store";
export const APIClubInventoryUpdate = BASE_URL+"/api/club/inventory/update";
export const APIClubInventoryDelete = BASE_URL+"/api/club/inventory/delete";
export const APIClubInventoryStocksByCounter = BASE_URL+"/api/club/inventory/stocks-by-counter";
export const APIClubInventoryReport = BASE_URL+"/api/club/inventory/report/report";
export const APIClubInventoryStats = BASE_URL+"/api/club/inventory/report/stats";
// Club Orders
export const APIClubOrderStore = BASE_URL + "/api/club/order/store";
export const APIClubOrderList = BASE_URL + "/api/club/order/list";
export const APIClubOrderPos = BASE_URL + "/api/club/order/pos";
export const APIClubOrderUpdate = BASE_URL + "/api/club/order/update";
export const APIClubOrderDelete = BASE_URL + "/api/club/order/delete";
export const APIClubOrderPayment = BASE_URL + "/api/club/order/payment";
export const APIClubOrderPending = BASE_URL + "/api/club/club-orders/pending";
// Club Orders Report APIs
export const APIClubOrdersReport = BASE_URL + "/api/club/order/report/list";
export const APIClubOrdersReportDetails = BASE_URL + "/api/club/order/report/details";
export const APIClubOrdersReportStatistics = BASE_URL + "/api/club/order/report/statistics";
export const APIClubOrdersReportExport = BASE_URL + "/api/club/order/report/export";
export const APIClubOrdersReportTrends = BASE_URL + "/api/club/order/report/trends";

// Club Day Clossing
export const APIClubDayClossingList = BASE_URL + "/api/club/day-clossing/list";
export const APIClubDayClossingCounterStock = BASE_URL + "/api/club/day-clossing/counter-stock";
export const APIClubDayClossingTodaySales = BASE_URL + "/api/club/day-clossing/today-sales";
export const APIClubDayClossingStore = BASE_URL + "/api/club/day-clossing/store";
export const APIClubDayClossingUpdateStatus = BASE_URL + "/api/club/day-clossing/update-status";
export const APIClubDayClossingDelete = BASE_URL + "/api/club/day-clossing/delete";
// report
// Day Closing Report APIs
export const APIClubDayClossingReport = BASE_URL + "/api/club/day-clossing/report/list";
export const APIClubDayClossingReportDetails = BASE_URL + "/api/club/day-clossing/report/details";
export const APIClubDayClossingReportStatistics = BASE_URL + "/api/club/day-clossing/report/statistics";
export const APIClubDayClossingReportExport = BASE_URL + "/api/club/day-clossing/report/export";
export const APIClubDayClossingReportTrends = BASE_URL + "/api/club/day-clossing/report/trends";
// ============================= club End ============================================


// ============================= Bar Start ============================================
// Stock APIs
export const APIBarStockList = BASE_URL + "/api/bar/stock/list";
export const APIBarStockNames = BASE_URL + "/api/bar/stock/names";
export const APIBarStockStats = BASE_URL + "/api/bar/stock/stats";
export const APIBarStockStore = BASE_URL + "/api/bar/stock/store";
export const APIBarStockUpdate = BASE_URL + "/api/bar/stock/update";
export const APIBarStockBalance = BASE_URL + "/api/bar/stock/stock-balance";
export const APIBarStockAdjust = BASE_URL + "/api/bar/stock/adjust";
export const APIBarStockDelete = BASE_URL + "/api/bar/stock/delete";
export const APIBarStockReport = BASE_URL + "/api/bar/stock/report";
export const APIBarStockUpdateBalance = BASE_URL + "/api/bar/stock/update-balance";
export const APIBarStockHistory = BASE_URL + "/api/bar/stock/history/";
export const APIBarStockTaking = BASE_URL + "/api/bar/stock/stock-taking";

// Bar Inventory APIs
export const APIBarInventoryList = BASE_URL+"/api/bar/inventory/list";
export const APIBarInventoryStore = BASE_URL+"/api/bar/inventory/store";
export const APIBarInventoryUpdate = BASE_URL+"/api/bar/inventory/update";
export const APIBarInventoryDelete = BASE_URL+"/api/bar/inventory/delete";
export const APIBarInventoryStocksByCounter = BASE_URL+"/api/bar/inventory/stocks-by-counter";
export const APIBarInventoryReport = BASE_URL+"/api/bar/inventory/report/report";
export const APIBarInventoryStats = BASE_URL+"/api/bar/inventory/report/stats";
// Bar Orders
export const APIBarOrderStore = BASE_URL + "/api/bar/order/store";
export const APIBarOrderPending = BASE_URL + "/api/bar/order/bar-orders/pending";
export const APIBarOrderList = BASE_URL + "/api/bar/order/list";
export const APIBarOrderPos = BASE_URL + "/api/bar/order/pos";
export const APIBarOrderUpdate = BASE_URL + "/api/bar/order/update";
export const APIBarOrderDelete = BASE_URL + "/api/bar/order/delete";
export const APIBarOrderPayment = BASE_URL + "/api/bar/order/payment";

// Bar Orders Report APIs
export const APIBarOrdersReport = BASE_URL + "/api/bar/order/report/list";
export const APIBarOrdersReportDetails = BASE_URL + "/api/bar/order/report/details";
export const APIBarOrdersReportStatistics = BASE_URL + "/api/bar/order/report/statistics";
export const APIBarOrdersReportExport = BASE_URL + "/api/bar/order/report/export";
export const APIBarOrdersReportTrends = BASE_URL + "/api/bar/order/report/trends";
// Bar Day Clossing
export const APIBarDayClossingList = BASE_URL + "/api/bar/day-clossing/list";
export const APIBarDayClossingTodaySales = BASE_URL + "/api/bar/day-clossing/today-sales";
export const APIBarDayClossingStore = BASE_URL + "/api/bar/day-clossing/store";
export const APIBarDayClossingUpdateStatus = BASE_URL + "/api/bar/day-clossing/update-status";
export const APIBarDayClossingDelete = BASE_URL + "/api/bar/day-clossing/delete";
export const APIBarDayClossingCheckExisting = BASE_URL + "/api/bar/day-clossing/check-existing";
// report
// Day Closing Report APIs
export const APIBarDayClossingReport = BASE_URL + "/api/bar/day-clossing/report/list";
export const APIBarDayClossingReportDetails = BASE_URL + "/api/bar/day-clossing/report/details";
export const APIBarDayClossingReportStatistics = BASE_URL + "/api/bar/day-clossing/report/statistics";
export const APIBarDayClossingReportExport = BASE_URL + "/api/bar/day-clossing/report/export";
export const APIBarDayClossingReportTrends = BASE_URL + "/api/bar/day-clossing/report/trends";
// ============================= Bar End ============================================

